import script from "./cashbackHistoryCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./cashbackHistoryCard.vue?vue&type=script&lang=ts&setup=true"

import "./cashbackHistoryCard.vue?vue&type=style&index=0&id=b2c9c6b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2c9c6b8"]])

export default __exports__